import PropTypes from 'prop-types';
import cn from 'classnames';
import React, {Component} from 'react';
import css from './css.css';
import commoncss from '~/themes/common.css';
import TableToggle from "~/ui/TableActionBar/TableToggle";
import TableActions from "~/ui/TableActionBar/TableActions";
import TableSettings from "~/ui/TableActionBar/TableSettings";

import { Center, HStack, IconButton, IconMenu, ScrollView, DrawerToggle } from '~/native-ui';
import { FilteredViews, SaveFilteredViews } from '~/ui/FilteredViews';
import Bar from '~/components/Bar/Bar';
import { withResponsiveFlags } from '~/hoc/withResponsiveProps';


const iconMenuProps = {
    icon: "cog",
    menuProps: {closeOnSelect: false },
    iconFamily: "material-community",
    buttonProps: { iconProps: { size: "sm", color: "primary.500", }, ml: 2, },
}


class TableActionBar extends Component {
    static propTypes = {
        modelId: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        addText: PropTypes.string.isRequired,
        onAdd: PropTypes.func.isRequired,
        onClose: PropTypes.func.isRequired,
        parentModelId: PropTypes.string,
        canCreate: PropTypes.bool.isRequired,
        isSmallScreen: PropTypes.bool,
    };

    state = {
        isOpen: false,
    }

    static getDerivedStateFromProps (props, state) {
        return {
            isOpen: props.isSmallScreen && state.isOpen,
        }
    }

    toggleMenu = () => {
        if (!this.props.isSmallScreen) return;
        this.setState({ isOpen: !this.state.isOpen })
    }

    renderDrawerToggle() {
        if (!this.props.isSmallScreen) return null
        return <DrawerToggle />
    }

    renderViewActionsMaybeWithButton = (children) => {
        if (!this.props.isSmallScreen) return children;

        return (
            <IconMenu
                {...iconMenuProps}
                isOpen={this.state.isOpen}
                onClose={this.toggleMenu}
                onOpen={this.toggleMenu}
            >
                {children}
            </IconMenu>
        )
    }


    getActionProps = () => {
        return !this.props.isSmallScreen ? {} : {
            mode: "menuitem",
        }
    }



    renderViewActions = () => {
        return this.renderViewActionsMaybeWithButton(
            <>
                <TableSettings {...this.getActionProps() } modelId={this.props.modelId} />
                <TableToggle {...this.getActionProps() } onPress={this.toggleMenu} modelId={this.props.modelId} />
            </>
        )

    }

    triggerProps = { ml: "1" }
    leftActions = () => {
        if (!this.props.parentModelId) {
            return (
                <HStack space="2" alignItems="center">
                    <HStack alignItems="center">
                        { this.renderDrawerToggle() }
                        <FilteredViews modelId={this.props.modelId} />
                        {this.renderViewActions()}
                    </HStack>
                    <SaveFilteredViews modelId={this.props.modelId} />
                </HStack>
            );
        }

        return (
            <Center width={40}>
                <IconButton
                    icon="arrow_back"
                    className={cn(commoncss.goBack, css.goBack)}
                    primary
                    onClick={this.props.onClose}
                />
            </Center>
        );
    };
    

    contentContainerStyle = {marginLeft: "auto", alignItems: "center"}
    rightActions = () => {
        const actions = <TableActions
            modelId={this.props.modelId}
            canCreate={this.props.canCreate}
            addText={this.props.addText}
            onAdd={this.props.onAdd}
            createTooltip={this.props.createTooltip}
        />

        if (this.props.isSmallScreen) return actions;
        return (
                <HStack pr="4">
                    <ScrollView horizontal ml="auto" contentContainerStyle={this.contentContainerStyle}>
                        {actions}
                    </ScrollView>
                </HStack>
        );
    };
    
    render() {
        return <Bar shadow="1" px="4" py="2" space="2" left={this.leftActions()} right={this.rightActions()} />
    }
}

export default withResponsiveFlags(TableActionBar, { includeKeys: ['isSM', 'isXS', 'isSmallScreen'] })